import React from "react";
import { observer } from "mobx-react-lite";
import {useStores} from "../hooks/useStores";
import "./ImageView.css";

const ImageView = observer((props) => {

    const {ImageStore} = useStores();
    const store = useStores();

    return (
        <React.Fragment>
            {ImageStore.images}
        </React.Fragment>
    )
});

export default ImageView;